export var SSRGetDoneMark = {
  getDoneMark: function () {
    return null;
  },
  setGetDoneMark: function setGetDoneMark(fn) {
    SSRGetDoneMark.getDoneMark = fn;
  }
};